import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const { loginWithToken } = useAuth();
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    window.history.replaceState(null, "", window.location.pathname);
    api.post("/auth/google", { session_id: sid })
      .then(({ data }) => { loginWithToken(data); toast.success("Bienvenido a NautaPOS"); navigate("/", { replace: true }); })
      .catch((e) => { toast.error(apiErr(e)); navigate("/login", { replace: true }); });
  }, [loginWithToken, navigate]);

  return <div className="min-h-screen flex items-center justify-center bg-background text-muted-foreground">Verificando cuenta de Google…</div>;
}
